<div class="auth-page">
  <div class="auth-card">
    @if (justConfirmed) {
      <h1 class="auth-heading">Choose your password</h1>
      <p class="text-green-600 text-center mt-0 mb-2">Your email address has been confirmed.</p>
      <p class="auth-subtitle">One more step. Choose a password, then you can sign in.</p>
    } @else {
      <h1 class="auth-heading">Create a new password</h1>
      <p class="auth-subtitle">Enter and confirm your new password.</p>
    }

    <form name="resetForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <p-password [(ngModel)]="newpassword" [toggleMask]="true" required name="newpassword" placeholder="New password"
          strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_\W])(?=.{8,})" styleClass="w-full"></p-password>
        <p-password [(ngModel)]="conpassword" [toggleMask]="true" required name="conpassword"
          placeholder="Confirm password" [feedback]="false" styleClass="w-full"></p-password>

        <prox-password-rules [password]="newpassword" [confirm]="conpassword"></prox-password-rules>

        <div class="flex gap-2 mt-2">
          <button pButton pRipple label="Cancel" type="button" class="flex-auto p-button-outlined" routerLink="/"></button>
          <button pButton pRipple label="Submit" type="submit" class="flex-auto"
            [disabled]="form.invalid || (conpassword !== newpassword) || !passwordMeetsRules(newpassword) || !!success"
            [loading]="working"></button>
        </div>

        @if (error) {
          <p class="text-red-500 text-center mt-3 mb-0">{{error}}</p>
        }
        @if (linkFailed) {
          <p class="text-center mt-2 mb-0">
            <a routerLink="/auth/forgot-password" class="text-primary font-medium hover:underline">Request a new reset link</a>
          </p>
        }
        @if (success) {
          <p class="text-green-500 text-center mt-3 mb-0">{{success}}</p>
        }
      </div>
    </form>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      A problem? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
